import { createFileRoute } from "@tanstack/react-router";
import { Button, Sticker } from "../components/ui";
import { SettingsHeader } from "../components/SettingsHeader";
import { reasonLabel, useCreditHistory } from "../lib/useCreditHistory";

export const Route = createFileRoute("/settings/usage")({
  component: UsageSettings,
});

function UsageSettings() {
  const history = useCreditHistory();
  const transactions = history.data?.pages.flatMap((p) => p.transactions) ?? [];

  return (
    <div>
      <SettingsHeader title="Usage">
        Every credit you bought, received, spent or lost to expiry.
      </SettingsHeader>

      <section className="tactile p-4 sm:p-6">
        {history.isLoading ? (
          <p className="py-8 text-center text-sm font-semibold text-ink-soft">
            Loading…
          </p>
        ) : history.isError ? (
          <p className="py-8 text-center text-sm font-semibold text-ink-soft">
            Could not load your credit history. Try again in a moment.
          </p>
        ) : transactions.length === 0 ? (
          <p className="py-8 text-center text-sm font-semibold text-ink-soft">
            Nothing yet — purchases and credit use will show up here.
          </p>
        ) : (
          <>
            <ul className="-my-1.5 divide-y-2 divide-line">
              {transactions.map((t) => (
                <li
                  key={t.id}
                  className="flex items-center justify-between gap-4 py-3"
                >
                  <div className="min-w-0">
                    <p className="truncate text-sm font-bold text-ink">
                      {reasonLabel(t.reason)}
                    </p>
                    <p className="text-xs font-semibold text-ink-faint">
                      {new Date(t.createdAt).toLocaleDateString()}
                    </p>
                  </div>
                  <Sticker tone={t.amount >= 0 ? "mint" : "neutral"} size="sm">
                    {t.amount >= 0 ? `+${t.amount}` : `−${Math.abs(t.amount)}`}
                  </Sticker>
                </li>
              ))}
            </ul>
            {history.hasNextPage && (
              <div className="mt-5 flex justify-center">
                <Button
                  variant="outline"
                  loading={history.isFetchingNextPage}
                  onClick={() => void history.fetchNextPage()}
                >
                  Show older
                </Button>
              </div>
            )}
          </>
        )}
      </section>
    </div>
  );
}
